var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "apartment-detail-card",
      attrs: {
        row: "",
        wrap: "",
        "mx-4": "",
        "pl-0": "",
        "mt-0": "",
        "mb-3": ""
      }
    },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "mt-2": "" } },
            [
              _c(
                "v-flex",
                [
                  _c("h1", { staticClass: "primary--text" }, [
                    _vm._v(
                      _vm._s(_vm.$t(_vm.lblSetting.blockOverallInformations))
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs2: "" } },
                    [
                      _c("v-card", {
                        attrs: {
                          flat: "",
                          color: "secondary",
                          height: "1px",
                          width: "100%"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            {
              attrs: {
                "px-0": "",
                "mt-2": "",
                row: "",
                wrap: "",
                "justify-start": ""
              }
            },
            [
              _c(
                "v-flex",
                {
                  ref: "mapContainerRef",
                  staticStyle: { height: "300px" },
                  style: _vm.dtStyle,
                  attrs: { "ml-0": "", "mr-1": "" }
                },
                [
                  _c(
                    "gmap-map",
                    {
                      staticStyle: { height: "100%", width: "100%" },
                      attrs: {
                        center: _vm.dtCenter,
                        zoom: 10,
                        "map-type-id": "terrain"
                      }
                    },
                    [
                      _vm.dtMarkerPosition
                        ? _c("gmap-marker", {
                            attrs: { position: _vm.dtMarkerPosition }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { "ml-3": "", xs9: "", md9: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "py-3 md12" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "", "justify-start": "" } },
                        [
                          _c("v-flex", { attrs: { xs4: "", "pl-3": "" } }, [
                            _c(
                              "ul",
                              {
                                staticClass:
                                  "pl-0 apartment--info__coordinates mt-2",
                                staticStyle: { "list-style": "none" }
                              },
                              [
                                !_vm.coLoader && !_vm.isApartmentAsBlock
                                  ? _c(
                                      "li",
                                      { staticClass: "mb-1" },
                                      [
                                        _c(
                                          "v-tooltip",
                                          { attrs: { left: "" } },
                                          [
                                            _c(
                                              "template",
                                              { slot: "activator" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      small: "",
                                                      color: "black"
                                                    }
                                                  },
                                                  [_vm._v("border_all")]
                                                ),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.floor_text) +
                                                    "\n                    "
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.lblSetting.apartmentForm
                                                      .floor
                                                  )
                                                )
                                              )
                                            ])
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  : _vm.coLoader
                                  ? _c("block-infos-loader", {
                                      attrs: { height: 15, width: 200 }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.coLoader
                                  ? _c(
                                      "li",
                                      { staticClass: "mb-1" },
                                      [
                                        _c(
                                          "v-tooltip",
                                          { attrs: { left: "" } },
                                          [
                                            _c(
                                              "template",
                                              { slot: "activator" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      small: "",
                                                      color: "black"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "signal_cellular_null"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.square_meter) +
                                                    "㎡\n                    "
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.lblSetting.apartmentForm
                                                      .surface
                                                  )
                                                )
                                              )
                                            ])
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  : _c("block-infos-loader", {
                                      attrs: { height: 15, width: 200 }
                                    }),
                                _vm._v(" "),
                                _vm.coAddress && _vm.coAddress.line1
                                  ? [
                                      !_vm.coLoader
                                        ? [
                                            _c(
                                              "v-tooltip",
                                              { attrs: { left: "" } },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "activator" },
                                                  [
                                                    _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "black"
                                                            }
                                                          },
                                                          [_vm._v("place")]
                                                        ),
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.coAddress
                                                                .line1
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.coAddress.line2
                                                      ? _c("li", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.coAddress
                                                                .line2
                                                            )
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "li",
                                                      {
                                                        staticClass: "ml-4 pl-1"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.coAddress
                                                              .zip_code
                                                          ) + " "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "ml-3"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.coAddress
                                                                  .city
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "li",
                                                      {
                                                        staticClass: "ml-4 pl-1"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.coAddress
                                                              .country
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.lblSetting
                                                          .apartmentForm.address
                                                      )
                                                    )
                                                  )
                                                ])
                                              ],
                                              2
                                            )
                                          ]
                                        : [
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("block-infos-loader", {
                                              attrs: { height: 10, width: 150 }
                                            }),
                                            _vm._v(" "),
                                            _c("block-infos-loader", {
                                              attrs: { height: 10, width: 100 }
                                            })
                                          ]
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isApartmentAsBlock
                                  ? [
                                      !_vm.coLoader
                                        ? _c(
                                            "li",
                                            { staticClass: "mb-1" },
                                            [
                                              _c(
                                                "v-tooltip",
                                                { attrs: { left: "" } },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "activator" },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            small: "",
                                                            color: "black"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "alternate_email"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.aptAsBlock
                                                              .email || "-"
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          _vm.lblSetting
                                                            .apartmentForm.email
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        : _c("block-infos-loader", {
                                            attrs: { height: 15, width: 200 }
                                          }),
                                      _vm._v(" "),
                                      !_vm.coLoader
                                        ? _c(
                                            "li",
                                            { staticClass: "mb-1" },
                                            [
                                              _c(
                                                "v-tooltip",
                                                { attrs: { left: "" } },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "activator" },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            small: "",
                                                            color: "black"
                                                          }
                                                        },
                                                        [_vm._v("call")]
                                                      ),
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.aptAsBlock
                                                              .landline || "-"
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          _vm.lblSetting
                                                            .apartmentForm
                                                            .landline
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        : _c("block-infos-loader", {
                                            attrs: { height: 15, width: 200 }
                                          })
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _vm.isApartmentAsBlock
                            ? [
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", "mt-2": "" } },
                                  [
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "pl-0 apartment--info__coordinates mt-2",
                                        staticStyle: { "list-style": "none" }
                                      },
                                      [
                                        !_vm.coLoader
                                          ? _c(
                                              "li",
                                              { staticClass: "mb-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "black"
                                                            }
                                                          },
                                                          [_vm._v("domain")]
                                                        ),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.aptAsBlock
                                                                .building
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.lblSetting
                                                              .apartmentForm
                                                              .buildingName
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _c("block-infos-loader", {
                                              attrs: { height: 15, width: 200 }
                                            }),
                                        _vm._v(" "),
                                        !_vm.coLoader
                                          ? _c(
                                              "li",
                                              { staticClass: "mb-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "black"
                                                            }
                                                          },
                                                          [_vm._v("device_hub")]
                                                        ),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.aptAsBlock
                                                                .hub || "-"
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.lblSetting
                                                              .apartmentForm.hub
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _c("block-infos-loader", {
                                              attrs: { height: 15, width: 200 }
                                            }),
                                        _vm._v(" "),
                                        !_vm.coLoader
                                          ? _c(
                                              "li",
                                              { staticClass: "mb-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "black"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "change_history"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.aptAsBlock
                                                                .building_activity ||
                                                                "-"
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.lblSetting
                                                              .apartmentForm
                                                              .activity
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _c("block-infos-loader", {
                                              attrs: { height: 15, width: 200 }
                                            }),
                                        _vm._v(" "),
                                        !_vm.coLoader
                                          ? _c(
                                              "li",
                                              { staticClass: "mb-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "black"
                                                            }
                                                          },
                                                          [_vm._v("functions")]
                                                        ),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.aptAsBlock
                                                                .building_function ||
                                                                "-"
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.lblSetting
                                                              .apartmentForm
                                                              .function
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _c("block-infos-loader", {
                                              attrs: { height: 15, width: 200 }
                                            }),
                                        _vm._v(" "),
                                        !_vm.coLoader
                                          ? _c(
                                              "li",
                                              { staticClass: "mb-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "black"
                                                            }
                                                          },
                                                          [_vm._v("title")]
                                                        ),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.type || "-"
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.lblSetting
                                                              .apartmentForm
                                                              .type
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _c("block-infos-loader", {
                                              attrs: { height: 15, width: 200 }
                                            }),
                                        _vm._v(" "),
                                        !_vm.coLoader
                                          ? _c(
                                              "li",
                                              { staticClass: "mb-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "black"
                                                            }
                                                          },
                                                          [_vm._v("category")]
                                                        ),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.aptAsBlock
                                                                .category || "-"
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.lblSetting
                                                              .apartmentForm
                                                              .category
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _c("block-infos-loader", {
                                              attrs: { height: 15, width: 200 }
                                            })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", "mt-2": "" } },
                                  [
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "pl-0 apartment--info__coordinates mt-2",
                                        staticStyle: { "list-style": "none" }
                                      },
                                      [
                                        !_vm.coLoader
                                          ? _c(
                                              "li",
                                              { staticClass: "mb-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "black"
                                                            }
                                                          },
                                                          [_vm._v("vpn_key")]
                                                        ),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.aptAsBlock
                                                                .acquisition ||
                                                                "-"
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.lblSetting
                                                              .apartmentForm
                                                              .acquisition
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _c("block-infos-loader", {
                                              attrs: { height: 15, width: 200 }
                                            }),
                                        _vm._v(" "),
                                        !_vm.coLoader
                                          ? _c(
                                              "li",
                                              { staticClass: "mb-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "black"
                                                            }
                                                          },
                                                          [_vm._v("date_range")]
                                                        ),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.aptAsBlock
                                                                .construction_date ||
                                                                "-"
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.lblSetting
                                                              .apartmentForm
                                                              .constructionDate
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _c("block-infos-loader", {
                                              attrs: { height: 15, width: 200 }
                                            }),
                                        _vm._v(" "),
                                        !_vm.coLoader
                                          ? _c(
                                              "li",
                                              { staticClass: "mb-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "black"
                                                            }
                                                          },
                                                          [_vm._v("stairs")]
                                                        ),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.aptAsBlock
                                                                .nb_floor || "-"
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.lblSetting
                                                              .apartmentForm
                                                              .nbFloor
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _c("block-infos-loader", {
                                              attrs: { height: 15, width: 200 }
                                            }),
                                        _vm._v(" "),
                                        !_vm.coLoader
                                          ? _c(
                                              "li",
                                              { staticClass: "mb-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "black"
                                                            }
                                                          },
                                                          [_vm._v("foundation")]
                                                        ),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.aptAsBlock
                                                                .nb_basement ||
                                                                "-"
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.lblSetting
                                                              .apartmentForm
                                                              .nbBasement
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _c("block-infos-loader", {
                                              attrs: { height: 15, width: 200 }
                                            }),
                                        _vm._v(" "),
                                        !_vm.coLoader
                                          ? _c(
                                              "li",
                                              { staticClass: "mb-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "black"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "local_parking"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.aptAsBlock
                                                                .nb_parking ||
                                                                "-"
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.lblSetting
                                                              .apartmentForm
                                                              .nbParking
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _c("block-infos-loader", {
                                              attrs: { height: 15, width: 200 }
                                            }),
                                        _vm._v(" "),
                                        !_vm.coLoader &&
                                        _vm.aptAsBlock.exclude_maintenance_cost
                                          ? _c(
                                              "li",
                                              { staticClass: "mb-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "activator" },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                              color: "black"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "engineering"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                _vm.lblSetting
                                                                  .apartmentExcludeFromMaintenanceCost
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.lblSetting
                                                              .apartmentForm
                                                              .excludeMaintenanceCost
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          : _vm.coLoader
                                          ? _c("block-infos-loader", {
                                              attrs: { height: 15, width: 200 }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$route.meta.hide_tenant_info
                            ? _c(
                                "v-flex",
                                { staticClass: "xs4", attrs: { "mt-2": "" } },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: { row: "", wrap: "", "mt-1": "" }
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.lblSetting.apartmentForm
                                                .tenant
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: { row: "", wrap: "", "mt-0": "" }
                                    },
                                    [
                                      !_vm.coLoader
                                        ? _c(
                                            "v-layout",
                                            { attrs: { column: "", wrap: "" } },
                                            [
                                              _vm.tenants &&
                                              _vm.tenants.length === 1
                                                ? _c(
                                                    "user-profile-enhanced-widget",
                                                    {
                                                      attrs: {
                                                        user: _vm.tenants[0],
                                                        "two-line": true
                                                      }
                                                    }
                                                  )
                                                : _vm.tenants.length > 1
                                                ? _c(
                                                    "v-carousel",
                                                    {
                                                      staticClass:
                                                        "contact--carousel",
                                                      attrs: {
                                                        height: "250",
                                                        cycle: false,
                                                        light: true
                                                      }
                                                    },
                                                    _vm._l(
                                                      _vm.tenants,
                                                      function(tenant, index) {
                                                        return _c(
                                                          "v-carousel-item",
                                                          { key: index },
                                                          [
                                                            _c(
                                                              "v-layout",
                                                              {
                                                                attrs: {
                                                                  row: "",
                                                                  wrap: "",
                                                                  "justify-center":
                                                                    "",
                                                                  "mt-4": ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      "ml-2": ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "user-profile-widget",
                                                                      {
                                                                        attrs: {
                                                                          user: tenant
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _c("strong", [_vm._v("-")])
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("block-infos-loader", {
                                                attrs: {
                                                  height: 10,
                                                  width: 220
                                                }
                                              })
                                            ],
                                            1
                                          )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$route.meta.hide_owner_info
                            ? _c(
                                "v-flex",
                                { attrs: { xs4: "", "mt-2": "" } },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: { row: "", wrap: "", "mt-1": "" }
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.lblSetting.apartmentForm.owner
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: { row: "", wrap: "", "mt-0": "" }
                                    },
                                    [
                                      !_vm.coLoader
                                        ? _c(
                                            "v-layout",
                                            { attrs: { column: "", wrap: "" } },
                                            [
                                              _vm.owners &&
                                              _vm.owners.length === 1
                                                ? _c(
                                                    "user-profile-enhanced-widget",
                                                    {
                                                      attrs: {
                                                        user: _vm.owners[0],
                                                        "two-line": true
                                                      }
                                                    }
                                                  )
                                                : _vm.owners.length > 1
                                                ? _c(
                                                    "v-carousel",
                                                    {
                                                      staticClass:
                                                        "contact--carousel",
                                                      attrs: {
                                                        height: "250",
                                                        cycle: false,
                                                        light: true,
                                                        flat: ""
                                                      }
                                                    },
                                                    _vm._l(_vm.owners, function(
                                                      owner,
                                                      index
                                                    ) {
                                                      return _c(
                                                        "v-carousel-item",
                                                        { key: index },
                                                        [
                                                          _c(
                                                            "v-layout",
                                                            {
                                                              attrs: {
                                                                row: "",
                                                                wrap: "",
                                                                "justify-center":
                                                                  "",
                                                                "mt-4": ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    xs10: "",
                                                                    "ml-3": ""
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "user-profile-widget",
                                                                    {
                                                                      attrs: {
                                                                        user: owner
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }),
                                                    1
                                                  )
                                                : _c("strong", [_vm._v("-")])
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("block-infos-loader", {
                                                attrs: {
                                                  height: 10,
                                                  width: 220
                                                }
                                              })
                                            ],
                                            1
                                          )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _vm.$route.meta["apartment_zone_allowed"]
                ? _c(
                    "v-flex",
                    { attrs: { xs6: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("h1", { staticClass: "primary--text mt-4" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(_vm.lblSetting.blockApartmentZones)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs1: "" } },
                                [
                                  _c("v-card", {
                                    attrs: {
                                      flat: "",
                                      color: "secondary",
                                      height: "1px",
                                      width: "100%"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        {
                          staticClass: "px-3 mt-2 md12",
                          attrs: { width: "100%" }
                        },
                        [
                          _vm.coLoader
                            ? _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c("block-infos-loader", {
                                    attrs: { width: "360" }
                                  })
                                ],
                                1
                              )
                            : _vm._l(
                                _vm.currentApartment.apartment_zones,
                                function(item) {
                                  return _c(
                                    "v-list",
                                    { key: item.id },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            "align-center": "",
                                            "justify-space-between": "",
                                            row: "",
                                            "fill-height": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { "my-1": "" } },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(item.name)
                                                }
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }
                              ),
                          _vm._v(" "),
                          _vm.currentApartment.apartment_zones.length === 0
                            ? _c(
                                "div",
                                { staticClass: "text-xs-center py-3" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t(_vm.lblSetting.lblNoRecords))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-md-center" },
                            [
                              _c("base-modal-submit-btn", {
                                attrs: {
                                  title: _vm.$t(_vm.lblSetting.btnSeeMore)
                                },
                                on: { record: _vm.goToZoneList }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isApartmentAsBlock
                ? _c(
                    "v-flex",
                    { attrs: { xs6: "" } },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            row: "",
                            wrap: "",
                            "mt-4": "",
                            "ml-4": _vm.$route.meta["apartment_zone_allowed"]
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "pl-1": "" } },
                            [
                              _c("h1", { staticClass: "primary--text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(_vm.lblSetting.apartmentReferent)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs3: "" } },
                                [
                                  _c("v-card", {
                                    attrs: {
                                      flat: "",
                                      color: "secondary",
                                      height: "1px",
                                      width: "100%"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            row: "",
                            wrap: "",
                            "ml-4": _vm.$route.meta["apartment_zone_allowed"]
                          }
                        },
                        [
                          _c(
                            "v-card",
                            { staticClass: "mt-2", attrs: { width: "100%" } },
                            [
                              _c(
                                "v-carousel",
                                {
                                  attrs: {
                                    height: "250",
                                    cycle: false,
                                    light: true
                                  }
                                },
                                _vm._l(_vm.favContactsIndexer, function(
                                  index,
                                  i
                                ) {
                                  return _c(
                                    "v-carousel-item",
                                    {
                                      key: typeof index === "object" ? i : index
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            row: "",
                                            wrap: "",
                                            "justify-center": "",
                                            "mt-4": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              class: {
                                                "xs4 pt-5 mt-4": _vm.coLoader,
                                                xs5: !_vm.coLoader
                                              },
                                              attrs: { "ml-2": "" }
                                            },
                                            [
                                              !_vm.coLoader
                                                ? _c("user-profile-widget", {
                                                    attrs: {
                                                      user:
                                                        _vm.favContacts[index]
                                                    }
                                                  })
                                                : _c("block-infos-loader", {
                                                    attrs: {
                                                      height: 220,
                                                      width: "360"
                                                    }
                                                  })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              class: {
                                                "xs4 pt-5 mt-4": _vm.coLoader,
                                                xs5: !_vm.coLoader
                                              },
                                              attrs: { "ml-2": "" }
                                            },
                                            [
                                              _vm.favContacts[index + 1]
                                                ? [
                                                    !_vm.coLoader
                                                      ? _c(
                                                          "user-profile-widget",
                                                          {
                                                            attrs: {
                                                              user:
                                                                _vm.favContacts[
                                                                  index + 1
                                                                ]
                                                            }
                                                          }
                                                        )
                                                      : _c(
                                                          "block-infos-loader",
                                                          {
                                                            attrs: {
                                                              width: "360"
                                                            }
                                                          }
                                                        )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canManageDocuments
                ? _c(
                    "v-flex",
                    {
                      class: {
                        xs12: _vm.wideDocsdisplay,
                        xs6: !_vm.wideDocsdisplay
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            row: "",
                            wrap: "",
                            "mt-4": "",
                            "ml-4": !_vm.wideDocsdisplay
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("h1", { staticClass: "primary--text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(_vm.lblSetting.blockRecentDocuments)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs2: "" } },
                                [
                                  _c("v-card", {
                                    attrs: {
                                      flat: "",
                                      color: "secondary",
                                      height: "1px",
                                      width: "100%"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            row: "",
                            wrap: "",
                            "ml-4": !_vm.wideDocsdisplay
                          }
                        },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "px-3 mt-2 md12",
                              attrs: {
                                width: "100%",
                                "ml-4":
                                  _vm.$route.meta["apartment_zone_allowed"]
                              }
                            },
                            [
                              _vm.dtRecentDocuments.length
                                ? _c(
                                    "v-list",
                                    { attrs: { "three-line": "" } },
                                    _vm._l(_vm.dtRecentDocuments, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "v-list-tile",
                                        { key: index },
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              staticStyle: {
                                                cursor: "pointer"
                                              },
                                              attrs: { column: "" },
                                              on: {
                                                click: function(e) {
                                                  return _vm.handleViewDocument(
                                                    e,
                                                    item.link
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        nowrap: "",
                                                        "mb-2": ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-avatar",
                                                        {
                                                          staticClass:
                                                            "ml-3 mt-2",
                                                          attrs: {
                                                            color: "primary"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "headline white--text",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "15px !important"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "attachment_type"
                                                                    )(item.name)
                                                                  ) +
                                                                  "\n                    "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "ml-4" },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(item.name)
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("p", {
                                                            staticStyle: {
                                                              margin: "0",
                                                              padding: "0",
                                                              color: "#999",
                                                              "font-size":
                                                                "15px"
                                                            },
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  _vm.lblSetting
                                                                    .blockDocumentText,
                                                                  {
                                                                    who:
                                                                      item.creator_name ||
                                                                      item.fk_media_entity,
                                                                    when:
                                                                      item.when
                                                                  }
                                                                )
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("hr", {
                                                attrs: {
                                                  size: "1px",
                                                  width: "100%",
                                                  color: "#DDD"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "my-4 ml-3",
                                      staticStyle: { color: "#AAA" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t(_vm.lblSetting.lblNoDocs))
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.dtMessageErrorModel
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleCloseErrorModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenDeleteMessage
        ? _c("base-delete-dialog", {
            attrs: {
              "is-loading": _vm.dtIsLoading,
              message: _vm.$t(_vm.lblSetting.apartmentDeleteMessage)
            },
            on: { cancel: _vm.handleDeleteCancel, delete: _vm.handleDeleteOK }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e362e82a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e362e82a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/block-apartments-detail/template.html
// module id = null
// module chunks = 